/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverwolfXPTransaction } from './OverwolfXPTransaction';
import {
    OverwolfXPTransactionFromJSON,
    OverwolfXPTransactionFromJSONTyped,
    OverwolfXPTransactionToJSON,
    OverwolfXPTransactionToJSONTyped,
} from './OverwolfXPTransaction';

/**
 * 
 * @export
 * @interface GetOverwolfXPResponse
 */
export interface GetOverwolfXPResponse {
    /**
     * 
     * @type {Array<OverwolfXPTransaction>}
     * @memberof GetOverwolfXPResponse
     */
    transactions: Array<OverwolfXPTransaction>;
    /**
     * 
     * @type {boolean}
     * @memberof GetOverwolfXPResponse
     */
    isWeeklyLimitFeedbackDismissed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetOverwolfXPResponse
     */
    weeklyXpLimit?: number;
}

/**
 * Check if a given object implements the GetOverwolfXPResponse interface.
 */
export function instanceOfGetOverwolfXPResponse(value: object): value is GetOverwolfXPResponse {
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function GetOverwolfXPResponseFromJSON(json: any): GetOverwolfXPResponse {
    return GetOverwolfXPResponseFromJSONTyped(json, false);
}

export function GetOverwolfXPResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfXPResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactions': ((json['transactions'] as Array<any>).map(OverwolfXPTransactionFromJSON)),
        'isWeeklyLimitFeedbackDismissed': json['isWeeklyLimitFeedbackDismissed'] == null ? undefined : json['isWeeklyLimitFeedbackDismissed'],
        'weeklyXpLimit': json['weeklyXpLimit'] == null ? undefined : json['weeklyXpLimit'],
    };
}

export function GetOverwolfXPResponseToJSON(json: any): GetOverwolfXPResponse {
    return GetOverwolfXPResponseToJSONTyped(json, false);
}

export function GetOverwolfXPResponseToJSONTyped(value?: GetOverwolfXPResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactions': ((value['transactions'] as Array<any>).map(OverwolfXPTransactionToJSON)),
        'isWeeklyLimitFeedbackDismissed': value['isWeeklyLimitFeedbackDismissed'],
        'weeklyXpLimit': value['weeklyXpLimit'],
    };
}

